/* eslint-disable */

export default {

}

//esimerkkifunktio
export function testi() {
  //console.log('test');
}

export function getUrlParameter(sParam) {
  var sPageURL = window.location.search.substring(1),
      sURLVariables = sPageURL.split('&'),
      sParameterName,
      i;

  for (i = 0; i < sURLVariables.length; i++) {
      sParameterName = sURLVariables[i].split('=');

      if (sParameterName[0] === sParam) {
          return sParameterName[1] === undefined ? true : decodeURIComponent(sParameterName[1]);
      }
  }
}

/* eslint-enable */ 



// WEBPACK FOOTER //
// ./scripts/autoload/customfunctions.js